(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pages-finder-backup"]) return;
  try {
    
  "use strict";

  $(document).on('shopify:section:load', function() {
    new theme.classes.finder();
    new theme.classes.carousel();
    window.setTimeout(function() {
      $('.finder__section').trigger('finder:create-top-carousel');
    });
  });

  $(document).ready(initDynamicSlides);

  function initDynamicSlides() {
    var slides = "";

    function addSlide(p) {
      var data_id = p.shade_code;
      var model_src = p.model;
      var smear_src = p.swatch;
      var tone = p.tone;
      var description = p.undertone;
      var price = p.price;
      var sku = p.currentVariantSku;
      var _id = p.currentVariantId;
      var url = p.url;
      var alt_text = {
        smear: theme.finder.translations.foundation_smear + ' ' + data_id + ':' + p.undertone
      };

      slides += '<figure class="carousel-body__slide" data-variant-id="' + _id +'" data-url="' + url + '" data-id="' + data_id + '">\
                <img src="' + theme.finder.images.placeholder + '" class="carousel-body__slide-main-img" data-lazy="' + model_src + '" alt="' + data_id + ': ' + description + '">\
                <img src="' + theme.finder.images.blank + '" class="carousel-body__slide-smear" data-lazy="' + smear_src + '" alt="' + alt_text.smear + '" />\
                <figcaption class="carousel-body__slide-caption">\
                  <div class="carousel-body__slide-caption__left-panel">\
                    <p class="carousel-body__slide-caption__left-panel-title">\
                      <strong>' + data_id + '</strong>\
                      <span class="carousel-body__pipe">|</span>\
                      <span class="carousel-body__tone">' + tone + '</span>\
                    </p>\
                    <small class="carousel-body__slide-caption__left-panel-subtitle">\
                      <div title="' + description + '" class="carousel-body__undertone">\
                      ' + description + '\
                      </div>\
                    </small>\
                  </div>\
                  <div class="carousel-body__slide-caption__right-panel">\
                    <form action="/cart/add" method="post" data-money-format="$" class="carousel-body__slide-caption__right-panel-product_form" id="AddToCartForm">\
                      <input type="hidden" class="product-select" name="id" data-sku="' + sku + '" value="' + _id + '" tabindex="-1">\
                      <strong class="carousel-body__slide-caption__right-panel-price">' + price + '</strong>\
                      <button type="submit" name="button" id="AddToCart" value="' + theme.finder.translations.add_to_bag + '" class="carousel-body__slide-caption__right-panel-button" tabindex="-1">\
                        <img role="presentation" class="carousel-body__slide-caption__right-panel-icon" src="' + theme.finder.images.cart_icon + '" alt="">\
                      </button>\
                    </form>\
                  </div>\
                </figcaption>\
              </figure>';
    }

    $.ajax('/pages/collectionjson?collection=fluidity-foundation&page=2')
      .done(function(data) {
        try {
          var products = $.parseJSON(data);

          for (var i = 0; i < products.products.length; i++) {
            addSlide(products.products[i]);
          }

          $('.carousel-body').append(slides);
          $('.finder__section').trigger('finder:create-top-carousel');
        } catch(err) {
          $('.finder__section').trigger('finder:create-top-carousel');
        }
      })
      .fail(function(err) {
        $('.finder__section').trigger('finder:create-top-carousel');
      });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pages-finder"] && !window.DesignMode) return;
  try {
    
  "use strict";

  $(document).on('shopify:section:load', function() {
    new theme.classes.finder();
    new theme.classes.carousel();
    window.setTimeout(function() {
      $('.finder__section').trigger('finder:create-top-carousel');
    });
  });

  $(document).ready(initDynamicSlides);

  function initDynamicSlides() {
    var slides = "";

    function addSlide(p) {
      var data_id = p.shade_code;
      var model_src = p.model;
      var smear_src = p.swatch;
      var tone = p.tone;
      var description = p.undertone;
      var price = p.price;
      var sku = p.currentVariantSku;
      var _id = p.currentVariantId;
      var url = p.url;
      var alt_text = {
        smear: theme.finder.translations.foundation_smear + ' ' + data_id + ':' + p.undertone
      };
      var available = p.available;

      slides += '<figure class="carousel-body__slide" data-variant-id="' + _id +'" data-url="' + url + '" data-id="' + data_id + '">\
                <img src="' + theme.finder.images.placeholder + '" class="carousel-body__slide-main-img" data-lazy="' + model_src + '" alt="' + data_id + ': ' + description + '">\
                <img src="' + theme.finder.images.blank + '" class="carousel-body__slide-smear" data-lazy="' + smear_src + '" alt="' + alt_text.smear + '" />\
                <figcaption class="carousel-body__slide-caption">\
                  <div class="carousel-body__slide-caption__left-panel">\
                    <p class="carousel-body__slide-caption__left-panel-title">\
                      <strong>' + data_id + '</strong>\
                      <span class="carousel-body__pipe">|</span>\
                      <span class="carousel-body__tone">' + tone + '</span>\
                    </p>\
                    <small class="carousel-body__slide-caption__left-panel-subtitle">\
                      <div title="' + description + '" class="carousel-body__undertone">\
                      ' + description + '\
                      </div>\
                    </small>\
                  </div>\
                  <div class="carousel-body__slide-caption__right-panel">\
                    <form action="/cart/add" method="post" data-money-format="$" class="carousel-body__slide-caption__right-panel-product_form" id="AddToCartForm">\
                      <input type="hidden" class="product-select" name="id" data-sku="' + sku + '" value="' + _id + '">';

      if (available){
                
        slides += '<strong class="carousel-body__slide-caption__right-panel-price">' + price + '</strong>\
                      <button type="submit" name="button" id="AddToCart" value="' + theme.finder.translations.add_to_bag + '" class="carousel-body__slide-caption__right-panel-button">\
                        <img role="presentation" class="carousel-body__slide-caption__right-panel-icon" src="' + theme.finder.images.cart_icon + '" alt="">\
                      </button>';
      }else{
           slides += '<div class="carousel-body__slide-caption__right-panel-button carousel-body__slide-caption--out-of-stock" aria-label="">\
                    <svg class="finder__icon finder__icon--out_of_stock">\
                      <use xlink:href="#finder__icon--out_of_stock"></use>\
                    </svg>\
                  </div>';

      } 
                     slides += '</form>\
                  </div>\
                </figcaption>\
              </figure>';
    }

    $.ajax('/pages/collectionjson?collection=fluidity-foundation&page=2')
      .done(function(data) {
        try {
          var products = $.parseJSON(data);

          for (var i = 0; i < products.products.length; i++) {
            addSlide(products.products[i]);
          }

          $('.carousel-body').append(slides);
          $('.finder__section').trigger('finder:create-top-carousel');
        } catch(err) {
          $('.finder__section').trigger('finder:create-top-carousel');
        }
      })
      .fail(function(err) {
        $('.finder__section').trigger('finder:create-top-carousel');
      });

  }


$(document).ready(function() {

    $('.carousel-body').on('afterChange', function(event, slick, currentSlide) {
      setTimeout(function() {
        $('.slick-slide.slick-current').attr('aria-hidden', false);
      }, 100);
    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();

};

// Reloads the section as you edit settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();


  } catch(e) { console.error(e); }
})();
})();
